import React from 'react';
import Link from "../components/Link";

const About = () => {
  return (
    <ul>
      <li><Link to="/about/me">Me</Link></li>
      <li><Link to="/about/initial-consultation">Initial Consultation</Link></li>
      <li><Link to="/about/origins-of-chiropractic">Origins of Chiropractic</Link></li>
      <li><Link to="/about/what-is-mctimoney">What is McTimoney?</Link></li>
      <li><Link to="/about/privacy-notice">Privacy Notice</Link></li>
    </ul>
  );
};

export default About;




// WEBPACK FOOTER //
// ./src/pages/about.js